import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as techApi from '../../lib/api/tech';

const [VIEW_TECH_MID, VIEW_TECH_MID_SUCCESS, VIEW_TECH_MID_FAILURE] =
    createRequestActionTypes('chance/VIEW_TECH_MID');
export const viewTechMid = createAction(VIEW_TECH_MID, (id) => id);
const viewTechMidSaga = createRequestSaga(VIEW_TECH_MID, techApi.getTechMidById);

const UNLOAD_TECH_MID = 'chance/UNLOAD_TECH_MID';
export const unloadTechMid = createAction(UNLOAD_TECH_MID);

const SET_TECH_MID = 'chance/SET_TECH_MID';
export const setTechMid = createAction(SET_TECH_MID, (tech) => tech);


export function* techMidSaga() {
    yield takeLatest(VIEW_TECH_MID, viewTechMidSaga);
}

const initialState = {
    techMid: null,
    error: null,
};

const techMid = handleActions(
    {
        [VIEW_TECH_MID_SUCCESS]: (state, { payload: data }) => ({
            ...state,
            techMid: data.info,
        }),
        [VIEW_TECH_MID_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
        [UNLOAD_TECH_MID]: () => initialState,
        [SET_TECH_MID]: (state, { payload: data }) => ({
            ...state,
            techMid: data,
        }),

    },
    initialState,
);

export default techMid;
